export default function fileActionCreators(resourceName, key, actionTypes, api) {
	if (resourceName == null) throw new Error('actionCreatorsFor: Expected resourceName');

	let actionCreators = {

		uploadFile: function (id, file, token) {
			return function (dispatch) {
				dispatch(actionCreators.request());

				if (typeof file === "string") {
					dispatch(actionCreators.success({
						data: file
					}));
					return;
				}

				return api.upload(id, file, token)
					.then(
						response => dispatch(actionCreators.success(response)),
						error => dispatch(actionCreators.failure(error))
					).then(
						response => dispatch(actionCreators.complete()),
						error => dispatch(actionCreators.complete())
					);
			}
		},

		request: function () {
			let name = resourceName + '_FILE_REQUEST';

			return {
				type: actionTypes[name]
			}
		},

		success: function (data) {
			let name = resourceName + '_FILE_SUCCESS';

			return {
				data: data.data,
				type: actionTypes[name]
			}
		},

		complete: function () {
			let name = resourceName + '_FILE_COMPLETE';

			return {
				data: {},
				type: actionTypes[name]
			}
		},

		failure: function (error, data) {
			let name = resourceName + '_FILE_FAILURE';
			assertError(name, error);

			return {
				data: data,
				error: error,
				type: actionTypes[name]
			}
		}
	};

	return actionCreators;
}